/**
 * ConfigBlocoSoon — card "Em breve" para a tela /settings.
 * Prefixo Config conforme isolamento F3.
 * Zero strings hardcoded — consume t().
 */

import { t, type TranslationKey } from '../lib/i18n';

interface ConfigBlocoSoonProps {
  /** Icone Material Symbols Rounded */
  readonly icon: string;
  /** Chave i18n do titulo */
  readonly titleKey: TranslationKey;
  /** Chave i18n da descricao */
  readonly descKey: TranslationKey;
  /** animation-delay em ms para o stagger de entrada */
  readonly animationDelay?: number;
}

export function ConfigBlocoSoon({
  icon,
  titleKey,
  descKey,
  animationDelay = 0,
}: ConfigBlocoSoonProps): JSX.Element {
  return (
    <section
      className="cfg-card-soon"
      style={{ animationDelay: `${animationDelay}ms` }}
      aria-label={t(titleKey)}
    >
      {/* Filete neutro — "em breve" nao recebe a assinatura tricolor */}
      <div className="cfg-card-soon-bar" aria-hidden="true" />

      <div className="cfg-soon-inner">
        <div className="cfg-soon-header">
          <span className="material-symbols-rounded cfg-soon-icon" aria-hidden="true">
            {icon}
          </span>
          <div className="cfg-soon-badge">
            <span className="material-symbols-rounded cfg-soon-badge-icon" aria-hidden="true">
              schedule
            </span>
            {t('settings.soonBadge')}
          </div>
        </div>

        <p className="cfg-soon-title">{t(titleKey)}</p>
        <p className="cfg-soon-desc">{t(descKey)}</p>
      </div>
    </section>
  );
}
